import React from "react";
import { Popover, Box, Typography, Divider, Grid, TextField, Button } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ReschedulePopover = ({
  open,
  anchorEl,
  onClose,
  dateVal,
  setDateVal,
  timeVal,
  setTimeVal,
  handleRescheduleSave,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: "#f9f9f9",
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.25)",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            mt: 1,
          },
        },
      }}
    >
      <Box sx={{ p: 2, width: 300 }}>
        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: "bold" }}>
          {t("admin.talentAcquisition.rescheduleMeeting")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label={t("admin.talentAcquisition.newDate")}
              type="date"
              fullWidth
              size="small"
              value={dateVal}
              onChange={(e) => setDateVal(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label={t("admin.talentAcquisition.newTime")}
              type="time"
              fullWidth
              size="small"
              value={timeVal}
              onChange={(e) => setTimeVal(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1} sx={{ mt: 1 }}>
            <Button size="small" color="inherit" onClick={onClose}>
              {t("common.cancel")}
            </Button>
            <Button
              size="small"
              onClick={handleRescheduleSave}
              sx={{
                borderRadius: "8px",
                "&:hover": { backgroundColor: "blue", color: "#fff" },
              }}
            >
              {t("common.confirm")}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Popover>
  );
};

ReschedulePopover.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.oneOfType([
    PropTypes.instanceOf(Element),
    PropTypes.object, // Handles virtual anchor/rect
  ]),
  onClose: PropTypes.func.isRequired,
  dateVal: PropTypes.string.isRequired,
  setDateVal: PropTypes.func.isRequired,
  timeVal: PropTypes.string.isRequired,
  setTimeVal: PropTypes.func.isRequired,
  handleRescheduleSave: PropTypes.func.isRequired,
};

export default ReschedulePopover;
